import React, { memo, useCallback } from 'react';

interface ActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'info';
}

const ActionButton = memo<ActionButtonProps>(({
  onClick,
  disabled = false,
  children,
  variant = 'secondary'
}) => {
  const baseClasses = "px-4 py-2 rounded-md transition-colors";

  const variantClasses = {
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    secondary: "text-gray-600 border border-gray-300 hover:bg-gray-50",
    info: "text-blue-600 border border-blue-300 hover:bg-blue-50"
  };

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${disabledClasses}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
});

interface BillingSettingsHeaderProps {
  loading: boolean;
  connected: boolean;
  onRefresh: () => void;
  onAddSettings: () => void;
}

const BillingSettingsHeader = memo<BillingSettingsHeaderProps>(({
  loading,
  connected,
  onRefresh,
  onAddSettings
}) => {

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-[#1e2c49]">포트빌 관리비 설정</h1>

        <div className="flex items-center space-x-3">
          <ActionButton
            onClick={onRefresh}
            disabled={loading}
            variant="secondary"
          >
            {loading ? '새로고침 중...' : '새로고침'}
          </ActionButton>

          <ActionButton
            onClick={onAddSettings}
            disabled={loading || !connected}
            variant="primary"
          >
            관리비 설정 추가
          </ActionButton>
        </div>
      </div>
    </div>
  );
});

ActionButton.displayName = 'ActionButton';
BillingSettingsHeader.displayName = 'BillingSettingsHeader';

export default BillingSettingsHeader;